import { Typography } from '@mui/material';
import styled from 'styled-components';
import { theme } from '../../themes/theme';
export const Container = styled.section `
  ${({ containerFlex }) => containerFlex && `flex: ${containerFlex};`}
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: ${(props) => (props.extend ? '100%' : `${props.columns * 352}px`)};
  height: ${(props) => { var _a; return (_a = props.height) !== null && _a !== void 0 ? _a : '100%'; }};
`;
export const Row = styled.div `
  display: flex;
  border-bottom: ${(props) => !props.description && `1px solid ${theme.palette.grey[200]}`};
  justify-content: space-between;
  width: 100%;
  &&:last-of-type {
    ${(props) => props.description &&
    `
      flex: 1;
      overflow: auto
    `}
  }
`;
export const InfoHeader = styled(Typography) `
  && {
    margin: 0 0 1rem 0;
    text-transform: uppercase;
  }
`;
export const InfoColumnContainer = styled.article `
  padding: 0.5rem 1rem;
  max-width: ${(props) => (props.extend ? '100%' : '320px')};
  width: calc(100% - 32px);
  height: calc(100% - 1rem);
  display: flex;
  flex-flow: column;
`;
export const InfoSectionColumn = styled.div `
  display: flex;
  flex-direction: column;
  width: ${(props) => `${(1 / props.columns) * 100}%`};
  height: 100%;
  &&:last-of-type {
    align-items: center;
  }
`;
export const LeftSideParagraph = styled.div `
  padding: 0.5rem 0;
  color: ${theme.palette.text.secondary};
  text-transform: capitalize;
  display: flex;
  align-items: center;
  max-width: 65%;
  min-width: 33%;
`;
export const RightSideParagraph = styled.div `
  padding: 0.5rem 0 0.5rem 0.5rem;
  text-align: right;
  color: ${theme.palette.text.primary};
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 15%;
  ${(props) => (props.allowBreakLine ? 'line-break: anywhere;' : '')};
`;
export const OneLineRemarkParagraph = styled.div `
  border-bottom: 1px solid ${theme.palette.grey[200]};
  padding: 0.5rem 0;
  text-align: left;
  color: ${theme.palette.text.primary};
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 25%;
  max-height: ${(props) => props.height && props.height};
  min-height: ${(props) => props.height};
`;
export const DisplayBlock = styled.div `
  width: 100%;
  display: flex;
  flex-flow: column;
`;
export const TopSideParagraph = styled.div `
  padding: 0.5rem 0;
  color: ${theme.palette.text.secondary};
`;
export const BottomSideParagraph = styled.div `
  border-bottom: 1px solid ${theme.palette.grey[200]};
  padding-bottom: 0.5rem;
  overflow-y: auto;
  max-height: ${(props) => (props.height ? props.height : props.maxheight)};
  min-height: ${(props) => props.height};
  width: 100%;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  color: ${theme.palette.text.primary};
  flex: 1;
`;
